<template>
  <ul class="breadcrumbs">
    <li class="breadcrumbs__crumb" v-for="(crumb, index) in crumbs">
      <svg-icon v-if="index == 0" class="breadcrumbs__home-icon"
                @click.native="crumbClickHandler(crumb, index)"
                :icon="homeOutline" :width="16" :height="16"></svg-icon>

      <span v-else class="breadcrumbs__name"
            @click="crumbClickHandler(crumb, index)">{{ crumb.name }}</span>

      <svg-icon v-if="hasSeparator(index)" class="breadcrumbs__separator"
                :icon="arrow" :width="5" :height="8"></svg-icon>
    </li>
  </ul>
</template>

<script>
  import SvgIcon from '@/components/common/svgIcon'
  import homeOutline from '@/assets/svg/home-outline.svg'
  import arrow from '@/assets/svg/arrow.svg'

  export default {
    components: {
      SvgIcon
    },
    props: ['crumbs'],
    data () {
      return {
        arrow,
        homeOutline
      }
    },
    methods: {
      hasSeparator (index) {
        return index < this.crumbs.length - 1
      },
      crumbClickHandler (crumb, index) {
        this.$emit('click', crumb, index)
      }
    }
  }

</script>

<style lang='scss'>
  $crumb-margin: rem(8);

  .breadcrumbs {
    display: flex;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;

    &__crumb {
      display: flex;
      align-items: center;
      min-width: 0;
      font-size: rem(12);
      text-transform: uppercase;

      &:first-child {
        // we dont want the home icon to shrink to fit
        flex-shrink: 0;
      }

      + .breadcrumbs__crumb {
        margin-left: $crumb-margin;
      }
    }

    &__name {
      flex: 1 1 auto;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        cursor: pointer;
        color: color(yellow);
      }
    }

    &__separator {
      flex-shrink: 0;
      margin-left: $crumb-margin;
      fill: color(grays, extra-light);
    }

    &__home-icon {
      display: inline;
      flex-shrink: 0;
      fill: transparent;
      stroke: color(yellow);
      vertical-align: middle;

      &:hover {
        cursor: pointer;
        fill: color(yellow);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// BreadCrumbs.vue?0d2e444c